import React from 'react';
import { FormProps, Modal, ModalBody } from 'react-bootstrap';
import PhoneForm, { Phone } from './PhoneForm';

export type customPhoneFormModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  existingPhone?: Phone;
  handleClose: () => void;
  handleSubmit: (formData: any) => void;
  formProps?: FormProps;
}>;

const PhoneFormModal = ({
  showModal = false,
  existingPhone,
  handleClose,
  handleSubmit,
  formProps,
  ...props
}: customPhoneFormModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="lg">
      <ModalBody className="pt-12">
        <PhoneForm
          existingPhone={existingPhone}
          {...formProps}
          handleClose={handleClose}
          handleOnSubmit={handleSubmit}
        />
      </ModalBody>
    </Modal>
  );
};

export default PhoneFormModal;
